import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  HostBinding,
  Input,
  Output,
  OnChanges,
  SimpleChanges,
  AfterViewInit
} from '@angular/core';
import { FileObject } from '@core/models/file-object.model';
import { FileInputState } from '@feature/forms/form-file-input/form-file-input.component';

import { BaseInputComponent } from '../base-input.component';
import { TypedFormGroup } from '@feature/forms/form-model';

export type FileChangeEvent = {
  file: FileObject | null;
  formFileComponent: FormFileComponent;
};

@Component({
    selector: 'wai-form-file',
    templateUrl: './form-file.component.html',
    styleUrls: ['./form-file.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class FormFileComponent extends BaseInputComponent implements OnChanges, AfterViewInit {
  public asTypedFormGroup = (x: unknown): TypedFormGroup<any> => x as TypedFormGroup<any>;

  @Input() public accept = '*';

  @HostBinding('class.wai-form-file') public className = true;

  @Input() public deleteCountdown: number | null = null;

  @Output() public fileOpen: EventEmitter<FileObject> = new EventEmitter<FileObject>();

  @Input() public hint: string;

  @Input() public label: string;

  @Input() public isDisabled: boolean;
  @Input() public forcedDisabled = false;
  /**
   * Force enable file uploads regardless of form state.
   * Used in client onboarding where uploads should always be enabled.
   */
  @Input() public forceEnabled: boolean = false;

  @Input()
  public get state(): FileInputState {
    return this._state;
  }

  public set state(state: FileInputState) {
    this._state = state;
    // needs extra change detection when setting value via reference to controller
    this.changeDetectorRef.markForCheck();
  }

  private _state: FileInputState = 'empty';

  @Output() public fileChange: EventEmitter<FileChangeEvent> = new EventEmitter<FileChangeEvent>(null);

  public ngOnChanges(changes: SimpleChanges): void {
    if (changes['isDisabled'] && this.control) {
      this.updateDisabledState();
    }
  }

  public ngAfterViewInit(): void {
    this.updateDisabledState();
  }

  private updateDisabledState(): void {
    if (this.isDisabled) {
      this.control.disable();
    } else {
      this.control.enable();
    }
  }

  public onFileChange(file: FileObject): void {
    this.fileChange.emit({
      file,
      formFileComponent: this,
    });
  }

  public onFileOpen(file: FileObject): void {
    this.fileOpen.emit(file);
  }
}
